
























import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import QualityAndSafetyManageOrg from './qualityAndSafetyManageOrg.vue'
import PersonInfoManage from './personInfoManage.vue'
import ProjectLeaderList from './projectLeaderList.vue'
import SelfTrialExpertList from './selfTrialExpertList.vue'
import InternalAuditExpertList from './internalAuditExpertList.vue'
import LetterOfCommitment from './letterOfCommitment.vue'
@Component({
    name:'personManage',
    components: {
    	QualityAndSafetyManageOrg,
        PersonInfoManage,
        ProjectLeaderList,
        SelfTrialExpertList,
        InternalAuditExpertList,
        LetterOfCommitment
    }
})
export default class PersonManage extends AbpBase {
    initData:any = {
        currentName: 'qualityAndSafetyManageOrg',
        pageCache: ['qualityAndSafetyManageOrg']
    }
    //切换详情内容
    Switch(name:any){
        this.initData.currentName = name;
        if(this.initData.pageCache.indexOf(name) == -1) {
        	this.initData.pageCache.push(name);
        }
    }
    showPage(name:any) {
    	//  || this.initData.pageCache.indexOf(name) >= 0
    	if(this.initData.currentName == name) {
    		return true;
    	}
    	return false;
    }
    async mounted() {
    	
    }
}
